import html from "csi/html";
import { COMPLIANCE_ANALYSIS_BASE_PRODUCT, COMPLIANCE_ANALYSIS_FLDS } from "csi/service/rightPaneService";
import { submitWriter } from "csi/service/writerService";
import WorkingCache from "csi/state/WorkingCache";
import { RightPaneAllowedFunction, RightPaneComponent } from "csi/state/rightPane";
import { localStore } from "csi/state/rootStore";
import { C8Node, ICache } from "csi/typings";
import Writer from "csi/xml/Writer";
import _ from "lodash";
import { action, makeObservable, observable } from "mobx";
import { isAllowedForBaseProductTypeFuncBaseProduct, isAllowedForBaseProductTypeFuncFLDS } from "./complianceAnalysisRightPaneService";

const DEFAULT_WIDTH: number = 404;

const allowedBaseProductTypes = ["Food", "FormulatedMaterial", "Material", "Style"];
const allowedDataSheetTypes = ["FoodBOM", "FoodLabelDataSheet", "RecipeDataSheet"];
export class ComplianceAnalysisPaneComponent extends RightPaneComponent {
	@observable.ref _complianceAnalysis: C8Node;
	@observable private _paneIsExpanded: boolean;

	readonly cache: ICache;

	/** compliance analysis node */
	get complianceAnalysis(): C8Node {
		return this._complianceAnalysis;
	}

	/** pane is expanded */
	get paneIsExpanded(): boolean {
		return this._paneIsExpanded;
	}

	/** set product compliance analysis node */
	@action setProductComplianceAnalysisNode = (prodComplAnalysisNode: C8Node): void => {
		this._complianceAnalysis = prodComplAnalysisNode;
	};

	/** delete specific product compliance analysis node */
	@action deleteProductComplianceAnalysis = async (prodComplAnalysisNode: C8Node): Promise<boolean> => {
		const prodComplAnalysisNodeUrl = prodComplAnalysisNode?.$URL;
		const writer = new Writer();

		try {
			writer.deleteNode(prodComplAnalysisNodeUrl);
			await submitWriter(writer);

			return true;
		} catch (e) {
			console.error("Error deleting ProductComplianceAnalysis: ", e);
			return false;
		}
	};

	/** set pane is expanded */
	@action setPaneIsExpanded = (isExpanded: boolean): void => {
		this._paneIsExpanded = isExpanded;
	};

	constructor(panelName: string, isAllowed: RightPaneAllowedFunction, view: string) {
		const dataSheetPaths = allowedBaseProductTypes.map((dataSheetType) => `(BaseProduct)Child:DataSheets(${dataSheetType})`);

		super(panelName, {
			getResizeWidth: (): number => { return localStore.right.width; },
			dependencyPaths: dataSheetPaths,
			icon: "ProductComplianceSystem/icon/ComplianceAnalysisResultsIcon",
			isAllowed,
			resizable: true,
			setResizeWidth: (w: number): void => { localStore.right.width = w; },
			view,
			viewWidth: DEFAULT_WIDTH + html.getVerticalScrollbarWidth(),
		});

		makeObservable(this);
		this.cache = new WorkingCache();
		this._paneIsExpanded = false;
	}
}

export class ComplianceAnalysisPaneComponentFLDS extends ComplianceAnalysisPaneComponent {
	constructor() {
		const isAllowed: RightPaneAllowedFunction = isAllowedForBaseProductTypeFuncFLDS(allowedDataSheetTypes);
		const view: string = "ProductComplianceSystem/ComplianceAnalysisResults/ComplianceAnalysisSlimOnInstanceFLDS";
		super(COMPLIANCE_ANALYSIS_FLDS, isAllowed, view);
	}
}

export class ComplianceAnalysisPaneComponentBaseProduct extends ComplianceAnalysisPaneComponent {
	constructor() {
		const isAllowed: RightPaneAllowedFunction = isAllowedForBaseProductTypeFuncBaseProduct(allowedBaseProductTypes);
		const view: string = "ProductComplianceSystem/ComplianceAnalysisResults/ComplianceAnalysisSlimOnInstanceBaseProduct";
		super(COMPLIANCE_ANALYSIS_BASE_PRODUCT, isAllowed, view);
	}
}
